// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".cb1eb37584bf9b641845dbfb902f9daab0902634.chunk.js";
};